module.exports = __webpack_public_path__ + "static/media/pool.8038d3b5.jpg";